export default {
  'cart.title': 'Shopping Cart',
  'cart.order_info': 'Order Information',
  'cart.action.delete': 'Delete',
  'cart.payment_status.unpaid': 'Unpaid',
  'cart.payment_status.fail': 'Payment Failed',
  'cart.error.out_of_stock': 'Item is out of stock',
  'cart.error.bundle_out_of_stock': 'Insufficient stock for bundle items',
  'cart.error.product_removed': 'Item has been removed',
  'cart.error.checkout_fail': 'Checkout failed',
  'cart.empty_text.one': 'Your shopping cart is empty',
  'cart.empty_text.two': 'Go explore more',
  'cart.go_to_checkout': 'Go to Checkout',
  'cart.keep_shopping': 'Continue Shopping',
  'cart.check_order_status': 'Check Order Status',
  'cart.return': 'Return',
  'cart.buyer_info': 'Buyer Information',
  'cart.buyer_info.error.phone_required': 'Please enter a contact phone number',
  'cart.buyer_info.error.phone_formatted': 'Invalid phone number format',
  'cart.buyer_info.error.location_required': 'Please select a city',
  'cart.buyer_info.error.invoice_carrier.phone.required': 'Please enter mobile barcode',
  'cart.buyer_info.error.invoice_carrier.phone.formatted': 'Invalid mobile barcode format',
  'cart.buyer_info.error.invoice_carrier.company.required': 'Please enter the company number',
  'cart.buyer_info.error.invoice_carrier.company.formatted': 'The company number must be 8 digits',
  'cart.buyer_info.error.invoice_carrier.company.verify': 'Invalid company number',
  'cart.buyer_info.error.invoice_carrier.company_title.required': 'Please enter the company name',
  'cart.buyer_info.contact_phone': 'Contact Phone',
  'cart.buyer_info.residential_area': 'Residential City',
  'cart.buyer_info.location': 'District',
  'cart.buyer_info.address': 'Address',
  'cart.buyer_info.invoice_carrier': 'Electronic Invoice Carrier',
  'cart.buyer_info.invoice_carrier.choose': 'Choose Carrier',
  'cart.buyer_info.company.title': 'Company Name',
} as Record<string, string>;
